export const COOKIE=".AspNetCore.Cookies";

// Links de la guía para mantener el perfil actualizado (popup de bienvenida).
export const WELCOME_GUIDE_LINKS = {
    REGISTRATION_FORM: "https://www.exiros.com/suppliers/help/SUP_ES_INV_Invitacion%20y%20Multifactor.pdf",   // Cómo completar mi formulario de registro (nuevos proveedores)
    DOCUMENTS_CHECKLIST: "https://stexirosportaldata002.blob.core.windows.net/ivalua/help/SUP_ES_DOC_Requeridos.pdf", // Checklist de Documentos
    UPDATE_CONTACTS: "https://www.exiros.com/suppliers/help/SUP_ES_CON_Actualizacion.pdf",   // Cómo actualizar los contactos de mi compañía
    ANSWER_CHANGE_REQUEST: "https://www.exiros.com/suppliers/help/SUP_ES_CRQ_Actualizacion.pdf", // Cómo responder a una petición de cambio
    UPDATE_GENERAL_INFO: "https://www.exiros.com/suppliers/help/SUP_ES_CRQ_Actualizacion.pdf",   // Cómo actualizar información general de mi compañía
    UPDATE_BANK_DATA: "https://www.exiros.com/suppliers/help/SUP_ES_BNK_ALL_Actualizacion.pdf",  // Cómo actualizar sus datos bancarios
    COUNTRY_CALL_CENTERS: "https://accounts.exiros.com/Login/ContactUs/?culture=es-AR"      // Números de Call Center por país ("encuéntrelos aquí")
};

export const SUPPORT_EMAIL = "support@suppliers.exiros.com";

export const ROUTES = {
    CONTACT_FORM:"/Contact/New/",
    SELECT_COUNTRY:"/SelectCountry/",
    DOCUMENTS:"/Document/",
    HOME:"/",
    TICKETS_LIST: "/ListadoConsultas/",
    TICKET_CREATION: "/NuevaConsulta/",
    ACCOUNT_STATUS: "/EstadoCuenta/"
}

export const DOCUMENT_INVOICE_MASK = {
    AR:{
        regexInput:/^[0-9]{0,5}[A-Z]{0,1}[0-9]{0,8}$/,
        regexValid:/^(\d{5})+([A-Z]{0,1})+(\d{8})/,
        placeholder:"00000X00000000",
        description:"5 Numeros 1 Letra Mayuscula 8 numeros"
    },
    MX:{
        regexInput:null,
        regexValid:null,
        placeholder:"",
        description:""
    },
    US:{
        regexInput:null,
        regexValid:null,
        placeholder:"",
        description:""
    },
    EC:{
        regexInput:null,
        regexValid:null,
        placeholder:"",
        description:""
    },
    PE:{
        regexInput:null,
        regexValid:null,
        placeholder:"",
        description:""
    },
    CO:{
        regexInput:null,
        regexValid:null,
        placeholder:"",
        description:""
    }
}

export const TICKET_TYPE = {
    INTERFERENCE : 4
}